// This barrel file follows a slight variation from what you would normally do
// Do not change this file.
import { Format } from "./format";
import { Generic } from "./generic";
import { Gradients } from "./gradients";
import { Intercom } from "./intercom";
import { Setup } from "./setup";

export const Utils = {
  ...Format,
  ...Generic,
  ...Gradients,
  ...Intercom,
  ...Setup,
};
